import { TextField } from '@mui/material'
import { usePersonaStore } from '../../../../../store/usePersonaStore'
import FilterChip from '../../../../portal/lesson/booking/TutorFilterControls/FilterChip'
import { experienceItems } from './content'
const ExperienceDurationSelect = () => {
  const {
    experienceDurationId,
    setExperienceDurationId,
    showCustomWorkDuration,
    customExperienceDuration,
    setCustomExperienceDuration,
    toggleShowCustomWorkDuration,
  } = usePersonaStore()

  return (
    <div className="flex flex-col p-[20px]">
      <span className="Headline3-22Bd">그 일의 직급을 알려주세요.</span>
      <div className="flex flex-wrap flex-row mt-[36px] gap-[8px]">
        {experienceItems.map((item) => (
          <FilterChip
            key={item.id}
            id={item.alt}
            name={item.value}
            checked={experienceDurationId === item.id}
            onClick={() => setExperienceDurationId(item.id)}
          />
        ))}

        <br />
        {/* <FilterChip
          id={'4'}
          name={'직접입력'}
          checked={showCustomWorkDuration}
          onClick={() => {
            toggleShowCustomWorkDuration()
          }}
        /> */}
      </div>
      {showCustomWorkDuration && (
        <TextField value={customExperienceDuration} onChange={(e) => setCustomExperienceDuration(e.target.value)} />
      )}
      <br />
    </div>
  )
}

export default ExperienceDurationSelect
